var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4229 8.3L8 10.6556L5.56571 8.3L3.95429 9.86667L6.38857 12.2222L3.96571 14.5778L5.57714 16.1444L8 13.7889L10.4229 16.1444L12.0343 14.5778L9.61143 12.2222L12.0343 9.86667L10.4229 8.3ZM12 1.11111L10.8571 0H5.14286L4 1.11111H0V3.33333H16V1.11111H12ZM1.14286 17.7778C1.14286 19 2.17143 20 3.42857 20H12.5714C13.8286 20 14.8571 19 14.8571 17.7778V4.44444H1.14286V17.7778ZM3.42857 6.66667H12.5714V17.7778H3.42857V6.66667Z",
    fill: "#B44466"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDelete);
export default __webpack_public_path__ + "static/media/ico-delete.1ee15015441f590eb8d75306d7976a6f.svg";
export { ForwardRef as ReactComponent };